import { ActiveFilters, Address, ADDRESS_FILTER_SOURCES } from './interfaces';

export const getFeedbackColors = (latestFeedbackStatus: string, feedbackColourCode?: string) => {
  return latestFeedbackStatus ? feedbackColourCode ?? 'var(--grayscale-content-2)' : '#E92C2C';
};

// ============ ADDRESS FILTER UTILS ============

/**
 * Checks if an address matches Longhorn criteria based on source and secondarySource
 */
const matchesLonghornCriteria = (source: string, secondarySource?: string): boolean => {
  // Condition 1: source is LONGHORN_CIU
  if (source === ADDRESS_FILTER_SOURCES.LONGHORN_CIU) return true;

  // Condition 2: source is CUSTOMER_OUTREACH AND secondarySource is LONGHORN_CIU
  if (
    source === ADDRESS_FILTER_SOURCES.CUSTOMER_OUTREACH &&
    secondarySource === ADDRESS_FILTER_SOURCES.LONGHORN_CIU
  ) {
    return true;
  }

  return false;
};

/**
 * Checks if an address (top-level or similarLocationEntities) matches Longhorn filter
 */
export const isLonghornAddress = (address: Address): boolean => {
  // Check top-level address
  if (matchesLonghornCriteria(address.source, address.secondarySource)) return true;

  // Check similarLocationEntities
  const hasSimilarLonghornLocation = address.similarLocationEntities?.some(entity =>
    matchesLonghornCriteria(entity.source, entity.secondarySource)
  );
  if (hasSimilarLonghornLocation) return true;

  return false;
};

/**
 * Checks if an address matches Customer Outreach filter (secondarySource is DATA_SUTRAM)
 */
export const isCustomerOutreachAddress = (address: Address): boolean => {
  return address.secondarySource === ADDRESS_FILTER_SOURCES.DATA_SUTRAM;
};

/**
 * Filters addresses based on active filters (OR logic)
 */
export const filterAddresses = (addresses: Address[], filters: ActiveFilters): Address[] => {
  const hasActiveFilters = filters.LONGHORN || filters.CUSTOMER_OUTREACH;

  if (!hasActiveFilters) return addresses;

  return addresses.filter(address => {
    // OR logic: include address if it matches ANY active filter
    if (filters.LONGHORN && isLonghornAddress(address)) return true;
    if (filters.CUSTOMER_OUTREACH && isCustomerOutreachAddress(address)) return true;
    return false;
  });
};
